export default __webpack_public_path__ + "static/media/metablog_logo.310d5989.png";